import React from 'react'
import ProjectComponentLeft from '../Components/ProjectComponentLeft'
import json_data from '../projects_data.json'
import ProjectComponentRight from '../Components/ProjectComponentRight'
import PersonalProjectComponent from '../Components/PersonalProjectComponent'

const ProjectsPage = () => {

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%", justifyContent: "space-between", gap: "20px", position: "relative" }}>
        <div id="carouselExampleControlsNoTouching" className="carousel slide" data-bs-touch="false" style={{ height: "100%", width: "100%" }}>

          {/* Carousel Inner Content */}
          <div className="carousel-inner">
            {json_data.projects.map((each_project, idx) => (
                <div key={idx} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>

                  <div className="d-none d-md-block">
                    <div style={{ display: "flex", flexDirection: "row", height: "100%", width: "100%", justifyContent: "space-between", gap: "20px" }}>

                      {/* Left Section */}
                      <div style={{ width: "50%" }} className='card'>
                        <ProjectComponentLeft data={each_project.left_section} />
                      </div>

                      {/* Right Section */}
                      {each_project.left_section.project_type === "Personal"
                        ?
                        <PersonalProjectComponent />
                        :
                        <ProjectComponentRight data={each_project.right_section} />
                      }
                    </div>
                  </div>
                </div>
            ))}
          </div>

          {/* Carousel Buttons */}
          <button style={{ position: "absolute", left: "-5%", top: "230px", borderRadius: "100%", width: "50px", height: "50px" }} className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControlsNoTouching" data-bs-slide="prev">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-arrow-left-circle-fill" viewBox="0 0 16 16">
              <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
            </svg>
          </button>
          <button style={{ position: "absolute", right: "-5%", top: "230px", borderRadius: "100%", width: "50px", height: "50px" }} className="carousel-control-next" type="button" data-bs-target="#carouselExampleControlsNoTouching" data-bs-slide="next">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
              <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z" />
            </svg>
          </button>
        </div>

      </div>
    </>
  )
}

export default ProjectsPage